import { DateTime } from 'luxon';
import { GERMAN_TIMEZONE, LATE_BOOKING_HOUR } from '../../constants';
import { nowInGermany } from './serverClock';

// Express surcharge: a transfer is late when it is booked a) for the same day;
// b) for the next day but booked at or after LATE_BOOKING_HOUR today. Munich time throughout.
const isTransferLate = (time, date) => {
    if (!time || !date) {
        return false;
    }

    const now = nowInGermany();
    const isNowAM = now.hour < LATE_BOOKING_HOUR;
    const transferDateTime = DateTime.fromISO(date + 'T' + time, { zone: GERMAN_TIMEZONE });

    const isBookingForToday = transferDateTime.hasSame(now, 'day');
    const isBookingForTomorrow = transferDateTime.hasSame(now.plus({ days: 1 }), 'day');

    return isBookingForToday || (!isNowAM && isBookingForTomorrow);
};

export { isTransferLate };
